import { computed } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';

interface AppMetadata {
        modules?: string[];
}

interface Auth0User {
        app_metadata?: AppMetadata;
        [key: string]: unknown;
}

export function useModuleAccess() {
        const auth0 = useAuth0();

        const allowedModules = computed<string[]>(() => {
                const user = auth0.user.value as Auth0User | undefined;
                return user?.app_metadata?.modules || [];
        });

        const canAccessModule = (moduleName: string): boolean => {
                if (!moduleName) return true;
                if (allowedModules.value.length === 0) return true;
                return allowedModules.value.includes(moduleName);
        };

        const hasFullAccess = computed(() => {
                return allowedModules.value.length === 0;
        });

        return {
                allowedModules,
                canAccessModule,
                hasFullAccess,
        };
}
